import { Breadcrumb } from 'antd';
import styles from './custom-breadcrumb.module.scss';
import Icon from '@ant-design/icons';
import ChevronRight from '@/assets/icons/chevron-right.svg?react';
import { Link } from 'react-router-dom';
import { BreadcrumbItems } from './custom-breadcrumb.types';

interface CustomBreadcrumbsProps {
  items: BreadcrumbItems;
}

const itemRender = (route: any, _: any, routes: any) => {
  const last = routes.indexOf(route) === routes.length - 1;
  return last ? (
    <span>{route.title}</span>
  ) : (
    <Link className={styles.link} to={route.path || '#'}>
      {route.title}
    </Link>
  );
};

export default function CustomBreadcrumb({ items }: CustomBreadcrumbsProps) {
  return (
    <Breadcrumb
      rootClassName={styles.breadcrumbs}
      separator={<Icon component={() => <ChevronRight />} />}
      itemRender={itemRender}
      items={items}
    />
  );
}
